import React, { Fragment } from 'react';
import ImageDummy from './ImageDummy';
import { DraggableComponentProps } from 'features/document/constants';
import { isImageElement } from 'utils/typeGuards';
import { useGetFileQuery } from 'features/files/filesApi';
import { Container } from './Image.styled';

const ImageComponent = ({ currentElement }: DraggableComponentProps) => {
  if (!isImageElement(currentElement)) {
    return null;
  }
  const {
    content: { id },
    style,
  } = currentElement;
  const { data } = useGetFileQuery(Number(id), { skip: id === null });

  return (
    <Fragment>
      {id ? (
        <Container style={{ justifyContent: style?.justifyContent }}>
          <img alt='uploaded-img' src={data?.data.url} style={{ maxWidth: '100%', ...style }} />
        </Container>
      ) : (
        <ImageDummy />
      )}
    </Fragment>
  );
};

export default ImageComponent;
